var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 41,
    viewBox: "0 0 43 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 1.61804L26.076 15.7016L26.1883 16.0471H26.5516H41.3599L29.3797 24.7513L29.0858 24.9648L29.1981 25.3103L33.7741 39.3939L21.7939 30.6897L21.5 30.4762L21.2061 30.6897L9.22589 39.3939L13.8019 25.3103L13.9142 24.9648L13.6203 24.7513L1.64007 16.0471H16.4484H16.8117L16.924 15.7016L21.5 1.61804Z",
    fill: "#E9BE50",
    stroke: "#E9BE50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStar);
export default __webpack_public_path__ + "static/media/filled-star.67605f699aed1e258342c38cfaefc7e9.svg";
export { ForwardRef as ReactComponent };